var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fragment",
    [
      _vm.hasData
        ? [_vm._t("default")]
        : _c(
            "div",
            { staticClass: "dash-card-content-fallback" },
            [
              _c("emerald-icon", {
                attrs: {
                  "data-testid": "icon-content-fallback",
                  icon: "dashboard",
                },
              }),
              _c(
                "emd-text",
                {
                  attrs: {
                    color: "#72737A",
                    "data-testid": "text-content-fallback",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("textContentFallback")) + " ")]
              ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }